export default __webpack_public_path__ + "66542787cd42bc181d97f3df7523615b.webp";